var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1331_45957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24007 1.42188H1.45597C1.10089 1.42188 0.8125 1.71027 0.8125 2.06534V7.49479C0.8125 7.84986 1.10089 8.13825 1.45597 8.13825H5.24007C5.59515 8.13825 5.88354 7.84986 5.88354 7.49479V2.06534C5.88187 1.71027 5.59348 1.42188 5.24007 1.42188ZM5.43178 7.49312C5.43178 7.59981 5.3451 7.68649 5.23841 7.68649H1.4543C1.34761 7.68649 1.26093 7.59981 1.26093 7.49312V2.06534C1.26093 1.95865 1.34761 1.87197 1.4543 1.87197H5.23841C5.3451 1.87197 5.43178 1.95865 5.43178 2.06534V7.49312Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68539 0H2.90128C2.54621 0 2.25781 0.288392 2.25781 0.643465C2.25781 0.768491 2.35783 0.868511 2.48286 0.868511C2.60788 0.868511 2.7079 0.768491 2.7079 0.643465C2.7079 0.536777 2.79459 0.450092 2.90128 0.450092H6.68539C6.79207 0.450092 6.87876 0.536777 6.87876 0.643465V6.07291C6.87876 6.1796 6.79207 6.26628 6.68539 6.26628C6.56036 6.26628 6.46034 6.3663 6.46034 6.49133C6.46034 6.61635 6.56036 6.71637 6.68539 6.71637C7.04046 6.71637 7.32885 6.42798 7.32885 6.07291V0.643465C7.32885 0.288392 7.04046 0 6.68539 0Z",
    fill: "#898989"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateTask);
export default __webpack_public_path__ + "static/media/DuplicateTask.929c276745d1c47a247b5a19676a74ea.svg";
export { ForwardRef as ReactComponent };